import React from "react";
import Layout from "../../components/Layout";
import emailIcon from "../../images/icons/emailIconBlack.svg";
import twitterIcon from "../../images/icons/twitterIconBlack.svg";
import linkedInIcon from "../../images/icons/linkedInIconBlack.svg";
import playIcon from "../../images/icons/largePlayIcon.svg";
import pauseIcon from "../../images/icons/pauseIcon.svg";
import playButton from "../../images/icons/playButton.svg";

import {
  articleContainer,
  headlineContainer,
  socialIconsContainer,
  articleImage,
  breadcrumb,
  copyContainer,
  canopyGreen,
  oceanicBlue,
  hiveYellow,
  carbonGrey,
  dawnPink,
  simpleColouredCopyBlock,
  simpleRichTextArea,
  show,
  hide,
  stickyHeadlineContainer,
  stickySocialIconsContainer,
  playerWrapper,
  videoPlayer,
  videoButton,
  videoPictureWrap,
  videoWrap,
  videoLaunch,
  multiComponentImage,
  imgLink,
} from "./Article.module.scss";
import {
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton,
} from "react-share";
import { GatsbyImage } from "gatsby-plugin-image";

import { Link } from "gatsby";
import parse from "html-react-parser";
import "intersection-observer";
import { useInView } from "react-intersection-observer";
import ScrollIndicator from "../../components/ScrollIndicator/ScrollIndicator";
import { useMedia } from "../../hooks/useMedia";
import Newsletter from "../../components/Newsletter/Newsletter";
import ContinueReading from "../../components/ContinueReading/ContinueReading";
import HubspotFormV2 from "../../components/HubspotFormV2/HubspotFormV2";
import Divider from "../../components/Divider/Divider";
import Moment from "react-moment";
import Modal from "react-responsive-modal";
import ReactPlayer from "react-player";

const colorLookup = {
  canopyGreen: canopyGreen,
  oceanicBlue: oceanicBlue,
  hiveYellow: hiveYellow,
  carbonGrey: carbonGrey,
  dawnPink: dawnPink,
};

const modalStyles = require("../../styles/formModal.module.scss");

const ArticleTemplate = (props) => {
  const {
    allArticles: { nodes: allArticles },
    article,
    url,
    article: {
      id: articleId,
      authors,
      copy,
      image,
      imagePopUpForm = null,
      publish_at,
      media_type: { tyoe: articleType },
      shortDesc,
      slug,
      multiComponent,
      continueReading,
      metaData,
    },
  } = props;
  const [open, setOpen] = React.useState(false);
  const [showPause, setShowPause] = React.useState(false);
  const [showPlay, setShowPlay] = React.useState(false);
  const [openHeaderModal, setOpenHeaderModal] = React.useState(false);
  const myRef = React.useRef(null);

  const video = article?.featureVideo?.video?.localFile?.publicURL;
  const transcript = article?.featureVideo?.transcript?.localFile?.publicURL;
  const mainImage =
    article?.image?.image?.localFile?.childImageSharp?.gatsbyImageData;
  const videoPoster =
    article?.featureVideo?.poster?.localFile?.childImageSharp
      ?.gatsbyImageData || null;

  const videoPause = () => {
    setShowPause(true);
    setShowPlay(false);
  };

  const videoPlay = () => {
    setShowPause(false);
    setShowPlay(true);
  };

  const launchVideo = () => {
    setOpen(true);
  };

  const onHeaderClick = () => {
    setOpenHeaderModal(true);
  };
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const [scrollRef, scrollnView] = useInView({
    /* Optional options */
    threshold: 0,
  });

  const { mediaType } = useMedia(
    ["(min-width: 1440px)", "(min-width: 769px)", "(max-width: 768px)"],
    [
      {
        mediaType: "desktop",
      },
      {
        mediaType: "tablet",
      },

      { mediaType: "mobile" },
    ],
    // Default object
    { mediaType: "mobile" }
  );

  return (
    <Layout
      seo={{
        title: metaData?.pageTitle,
        description: metaData?.metadescription,
        image: image?.image?.localFile.publicURL,
        article: true,
        noindex: new Date(publish_at) > Date.now() ? true : false,
      }}
    >
      <div className={articleContainer}>
        <Link className={breadcrumb} to="/insights/latest-insights/">
          LATEST INSIGHTS
        </Link>
        <div className={headlineContainer}>
          <h2>{shortDesc}</h2>
          {authors?.length === 0 ? (
            <p className="ui">
              <Moment format="D MMM YYYY">{publish_at}</Moment>
            </p>
          ) : (
            authors?.map(({ name, id }) => {
              return (
                <p key={id} className="ui">
                  {publish_at ? (
                    <>
                      <Moment format="D MMM YYYY">{publish_at}</Moment>,{" "}
                    </>
                  ) : null}
                  {name}
                </p>
              );
            })
          )}

          {/* Temporarily commented out.  to be added later
          <div className={tagsContainer}>
            <p className="ui">retirement</p>
            <p className="ui">dws</p>
          </div> */}

          <div className={socialIconsContainer}>
            <p className="ui">SHARE</p>
            <TwitterShareButton url={url} quote={shortDesc}>
              <img src={twitterIcon} alt="twitter-icon" />
            </TwitterShareButton>
            <LinkedinShareButton url={url} title={shortDesc}>
              <img src={linkedInIcon} alt="linkedin-icon" />
            </LinkedinShareButton>
            <EmailShareButton url={url} subject={shortDesc}>
              <img src={emailIcon} alt="email-icon" />
            </EmailShareButton>
          </div>
        </div>

        <div
          ref={scrollRef}
          className={`${articleImage} ${imagePopUpForm ? imgLink : ""}`}
          onClick={imagePopUpForm ? onHeaderClick : null}
        >
          {article?.featureVideo ? (
            <div className={videoPictureWrap} onClick={() => launchVideo()}>
              <GatsbyImage
                image={videoPoster ? videoPoster : mainImage}
                alt={article?.featureVideo?.poster?.localFile?.alternativeText}
              />

              <div className={videoWrap}>
                <img
                  src={playButton}
                  alt="launch video"
                  className={videoLaunch}
                />{" "}
              </div>
            </div>
          ) : (
            <GatsbyImage
              image={mainImage}
              alt={image?.image?.alternativeText}
            />
          )}
        </div>

        {/* Sticky headline on scroll */}
        <div
          className={`${stickyHeadlineContainer} ${scrollnView ? hide : show}`}
        >
          {mediaType === "mobile" ? null : (
            <GatsbyImage
              image={mainImage}
              alt={image?.image?.alternativeText}
            />
          )}
          {mediaType === "mobile" ? null : <p className={`ui`}>{shortDesc}</p>}
          <div className={stickySocialIconsContainer}>
            <p className="ui">SHARE</p>
            <LinkedinShareButton url={url} title={shortDesc}>
              <img src={linkedInIcon} alt="linkedin-icon" />
            </LinkedinShareButton>
            <EmailShareButton url={url} subject={shortDesc}>
              <img src={emailIcon} alt="email-icon" />
            </EmailShareButton>
            <TwitterShareButton url={url} quote={shortDesc}>
              <img src={twitterIcon} alt="twitter-icon" />
            </TwitterShareButton>
          </div>
          <ScrollIndicator />
        </div>

        <div className={copyContainer}>{copy ? parse(copy) : null}</div>
        {multiComponent.map((component) => {
          const { strapi_component, id } = component;
          switch (strapi_component) {
            case "simple.coloured-copy-block":
              const { copy, backgroundColor } = component;

              return (
                <div
                  key={id}
                  className={`${simpleColouredCopyBlock} ${colorLookup[backgroundColor]}`}
                >
                  {copy ? parse(copy) : null}
                </div>
              );

            case "simple.rich-text-area":
              const { text } = component;
              return (
                <div key={id} className={`${simpleRichTextArea}`}>
                  {text ? parse(text) : null}
                </div>
              );

            case "simple.image-block":
              const { image } = component;
              return (
                <div key={id} className={`${multiComponentImage}`}>
                  <picture>
                    <source srcset={image?.url} media="(min-width: 1100px)" />
                    <source
                      srcset={image?.formats?.large?.url}
                      media="(min-width: 769px)"
                    />
                    <source
                      srcset={image?.formats?.medium?.url}
                      media="(min-width: 376px)"
                    />
                    <img
                      src={image?.formats?.small?.url}
                      alt={image?.alternativeText}
                    />
                  </picture>
                </div>
              );

            default:
              return null;
          }
        })}

        <Divider />

        {articleType != "Video" && (
          <ContinueReading
            allArticles={allArticles}
            continueReadingArticles={continueReading}
            currentArticleId={articleId}
            inView={inView}
          />
        )}

        <Newsletter ref={ref} />
      </div>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        center
        container={myRef.current}
        classNames={{
          overlay: "customOverlay",
          modal: "customModal",
          closeIcon: "closeIcon",
          closeButton: "closeButton",
        }}
      >
        <div className={playerWrapper}>
          <ReactPlayer
            className={videoPlayer}
            url={video}
            controls
            width="100%"
            height="calc(100vh - 2.4rem)"
            muted={false}
            onPause={videoPause}
            onPlay={videoPlay}
            playing
            config={{
              file: {
                attributes: {
                  controlsList: "nodownload",
                },
                tracks: [
                  {
                    kind: "subtitles",
                    src: transcript,
                    srcLang: "en",
                    default: false,
                  },
                ],
              },
            }}
          />
          {showPause ? (
            <div className={videoButton}>
              <img src={pauseIcon} alt="video paused" />
            </div>
          ) : null}
          {showPlay ? (
            <div className={videoButton}>
              <img src={playIcon} alt="video playing" />
            </div>
          ) : null}
        </div>
      </Modal>
      {imagePopUpForm ? (
        <Modal
          open={openHeaderModal}
          onClose={() => setOpenHeaderModal(false)}
          center
          classNames={{
            overlay: "customOverlay",
            modal: modalStyles.formModal,
            closeIcon: modalStyles.formCloseIcon,
            closeButton: modalStyles.formCloseButton,
          }}
        >
          <>
            <HubspotFormV2
              formId={imagePopUpForm.hubspotCode}
              recaptureId="how-it-works"
              title={imagePopUpForm.heading}
              alwaysConsent={true}
              isPopup={true}
              titleDescription={imagePopUpForm.mainCopy}
              confirmationMessage={imagePopUpForm.confirmationCopy}
              submitButton={{
                bkgColor: "blackOnLight",
              }}
              selectStyles={{
                option: (provided) => ({
                  ...provided,
                  color: "black",
                }),
                placeholder: (provided) => ({
                  ...provided,
                  color: "#2d2d2d",
                  opacity: 0.4,
                }),
                singleValue: (provided) => ({
                  ...provided,
                  color: "#2d2d2d",
                }),
                valueContainer: (provided) => ({
                  ...provided,
                  color: "#2d2d2d",
                  height: "50px",
                }),
                control: (provided, state) => ({
                  ...provided,
                  backgroundColor: "transparent",
                  border: "1px solid #2d2d2d",
                  width: "100%",
                  color: "white",
                  borderRadius: "0",
                  marginBottom: "10px",
                }),
              }}
            />
          </>
        </Modal>
      ) : null}
    </Layout>
  );
};

export default ArticleTemplate;
